// src/views/dashboard/salesrep/BillingConfirmationModal.jsx
import React from "react";
import { IoCloseOutline, IoCheckmarkCircle, IoAlertCircle } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";

const BillingConfirmationModal = ({ isOpen, onConfirm, onCancel, orderNumber }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 overflow-y-auto">
        {/* Backdrop */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/60 backdrop-blur-sm"
          onClick={onCancel}
        />

        {/* Modal */}
        <div className="flex min-h-full items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            className="relative bg-white dark:bg-gray-800 rounded-3xl shadow-2xl w-full max-w-md overflow-hidden border border-gray-200 dark:border-gray-700"
          >
            {/* Header */}
            <div className="relative bg-gradient-to-r from-amber-500 to-orange-500 p-6">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-40 h-40 bg-orange-600/20 rounded-full blur-3xl"></div>
              
              <div className="relative z-10">
                <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <IoAlertCircle className="text-white text-4xl" />
                </div>
                <h2 className="text-2xl font-black text-white text-center">
                  Billing Confirmation Required
                </h2>
                <p className="text-white/90 text-center mt-2 text-sm">
                  Order #{orderNumber}
                </p>
              </div>
            </div>

            {/* Content */}
            <div className="p-6">
              <div className="bg-amber-50 dark:bg-amber-900/20 border-2 border-amber-200 dark:border-amber-800 rounded-2xl p-4 mb-6">
                <p className="text-lg font-bold text-gray-900 dark:text-white text-center mb-2">
                  Have you confirmed billing and documentation is in place?
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
                  This action confirms that all required billing and documentation has been verified.
                </p>
              </div>

              {/* Buttons */}
              <div className="grid grid-cols-2 gap-3">
                <motion.button
                  onClick={onCancel}
                  className="px-6 py-4 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-white rounded-xl font-bold hover:bg-gray-300 dark:hover:bg-gray-600 transition-all flex items-center justify-center gap-2"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <IoCloseOutline className="text-xl" />
                  No
                </motion.button>
                <motion.button
                  onClick={onConfirm}
                  className="px-6 py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl font-bold hover:from-green-600 hover:to-emerald-700 transition-all shadow-lg flex items-center justify-center gap-2"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <IoCheckmarkCircle className="text-xl" />
                  Yes, Confirmed
                </motion.button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </AnimatePresence>
  );
};

export default BillingConfirmationModal;